import React from 'react';
import { UpdateBankInfo } from 'components';

export default function UpdateBankComponent() {
    return <UpdateBankInfo />;
}
